<template>
  <div id="app" ref="app" :style="{fontSize: fontSize + 'px', width: overWidth + 'px'}"> 
    <div class="container">
      <div class="sticky">
        <i class="sticky-left"></i>
        <i class="sticky-right"></i>
      </div>
      <div class="mark"></div>
      <Module class="app-module" id="module">
        <header>亲爱的用户：</header>
        <article>
           <h2 v-if="mulfrom" class="content-title1">苹果版双开助手上线了，诚邀你抢先体验！</h2>
           <h2 v-else class="content-title2">你是否存在这些苹果手机困扰？</h2>
            <ul class="content-list">
              <li v-for="(item, index) in copys[mulfrom]" :key="index">
                <i class="right-icon"></i>
                <p class="content-item">{{ item }}</p>
              </li>
            </ul>
          <!-- <h3 class="content-title">同时登录两个微信</h3> -->
          <div class="img-container"></div>
          <h2 v-if="!mulfrom">苹果版双开助手正式上线了，诚邀你抢先体验！多个账号同时在线，无需越狱，安全不封号！</h2>
          <!-- <p style="font-size: .92em"><span>*</span>成功参加的用户，在产品正式上线 AppStore 后，可获得三倍 VIP 权益！</p> -->
          <div class="step-conetnt">
            <h3>
              <span><i class="step-icon"></i><span>安装步骤</span></span>
              <a href="http://www.dualaid.com/InstallRequired">安装必读&nbsp;&rsaquo;&rsaquo;</a>
            </h3>
            <div class="step-tip">
              <div class="step step-1">
                <h4>步骤1</h4>
                <button @click="install()">点击安装 TestFlight </button>
                <p class="desc">TestFlight是苹果官方出品的应用，需要先安装此应用后，才能安装苹果版双开助手</p>
              </div>
              <div class="step step-2" id="step2">
                <h4>步骤2</h4>
                <button @click="inputEmail()">已安装TestFlight，点击安装</button>
                <!-- <p class="description">（PS:双开助手内测版暂更名为“社交工具箱”）</p> -->
                <p class="desc">请确认已安装TestFlight，再点击此按钮</p>
              </div>
            </div>
          </div>
          <span style="font-weight:700">欢迎加入苹果版双开助手用户群：<span style="color: #323ffd;font-weight:600">859309868</span></span>
        </article>
      </Module>
    </div>
    <loading :show="loadingShow" :text="loadingText"></loading>
    <toast :show="toastShow" :msg="toastMsg" :cls="leave"></toast>
    <Dialog :show="dialogShow" @hideDialog="hideDialog" text1="提交成功!" text2="TestFLight会在48小时之内" text3="发送邀请码至预留邮箱" btnText="好的"></Dialog>
    <Alert :show="alertShow" @hideAlert="hideAlert" :text="alertText"></Alert>
    <!-- <InputDialog @btnEvent="handleInput" :show="inputShow" @hideInput="hideInput" :scrollHeight="scrollHeight" placeholder="请输入您的邮箱" btnText="获取内测邀请码"></InputDialog> -->
  </div>
</template>

<script>
// const mailReg = /^[_a-z0-9-]+(\.[_a-z0-9-]+)*@[a-z0-9-]+(\.[a-z0-9-]+)*(\.[a-z]{2,})$/

import Module from './components/Module.vue'
import Toast from './components/Toast.vue'
import Loading from './components/Loading.vue'
import Dialog from '@/components/Dialog.vue'
import Alert from '@/components/Alert.vue'
// import InputDialog from '@/components/InputDialog.vue'

import qs from 'qs'
import wx from 'weixin-js-sdk'
// import { Dialog as vDialog } from 'vant'
import { setTimeout } from 'timers';

export default {
  name: 'app',
  components: {
    Module,
    Toast,
    Loading,
    Dialog,
    Alert
  },
  data () {
    return {
      overWidth: document.documentElement.clientWidth,
      overHeight: document.documentElement.clientHeight,
      fontSize: 14,
      alertText: '',
      toastShow: false,
      toastMsg: '',
      leave: false,
      dialogShow: false,
      loadingShow: false,
      loadingText: '正在提交...',
      alertShow: false,
      inputShow: false,
      params: this.getParams(),
      pushid: '', // 消息推送id
      sid: '', // 用户唯一id
      userid:'',
      btn1:'',
      btn1an:'',
      btn2:'',
      btn2an:'',
      formData: {
        email: ''
      },
      copys: [
        ['2个微信、QQ账号，频繁退出、登录。',
        '苹果手机如何安装2个微信、QQ、支付宝、微博。',
        '因为使用了“未受信任”的双开软件惨遭封号。',
        '第三方双开软件，消息推送不及时。'],
        ['2个微信、QQ、支付宝、微博，同时在线。',
        '无需越狱，无需企业证书，安全不封号。',
        '多账号消息提醒及时。']
      ],
      isWX: navigator.userAgent.toLowerCase().match(/MicroMessenger/i) == "micromessenger",
      isIOS: !!navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/),
      scrollHeight: 0 // 输入框失焦后的滚动距离优化
    }
  },
  computed: {
    mulfrom () {
      if (this.params['mulfrom'] === 'page2') return 1
      return 0
    }
  },
  watch: {
    overWidth (val) {
      this.overWidth = val
      this.setSize()
    }
  },
  methods: {
    getFontSize () {
      return this.overWidth / 320 * 12
    },
    setSize () {
      if (this.overWidth / this.overHeight > 0.7) { this.overWidth = this.overHeight * 0.7} 
      this.fontSize = this.getFontSize()
    },
    getParams () { // 获取链接参数
      let url = location.search
      let theRequest = new Object()
      if (url.indexOf('?') != -1) {
        let str = url.substr(1)
        let strs = str.split('&')
        for (var i = 0; i < strs.length; i++) {
          theRequest[strs[i].split('=')[0]] = (strs[i].split('=')[1])
        }
      }
      return theRequest
    },
    randomWord(randomFlag, min, max) { // 随机字符串
      var str = "",
          range = min,
          arr = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', 'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z', 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z']
      // 随机产生
      if (randomFlag) {
        range = Math.round(Math.random() * (max - min)) + min
      }
      for (var i = 0; i < range; i++) {
        var pos = Math.round(Math.random() * (arr.length - 1))
        str += arr[pos]
      }
      return str
    },
    hideDialog () {
      this.dialogShow = false
    },
    hideAlert () {
      this.alertShow = false
    },
    hideInput () {
      this.inputShow = false
    },
    toastDialog (msg) { // toast显示
      this.leave = false
      this.toastShow = true
      this.toastMsg = msg
      setTimeout(() => {
        this.leave = true       
      }, 2000)
      setTimeout(() => {
        this.toastShow = false        
      }, 2300)
    }, 
    verify (obj) { // 内容校验
      let ver = true
      for (let name in obj) {
        if (!obj[name]) {
          ver = false
        }
      }
      return ver
    },
    install () { // 跳转至AppStore
      if (this.isIOS) {
        this.statis(2) // 步骤一iOS的点击
        if ( this.params['from'] ) {
          if (localStorage.getItem('sk_btn1'+this.params['from'])) {
            this.sharechannel(2,0) //页面pv
          } else {
            this.btn1 = this.randomWord(false, 10)
            localStorage.setItem('sk_btn1'+this.params['from'], this.btn1)
            this.sharechannel(2,1) //页面uv
          }
        } else if ( this.params['mulfrom'] ) {
          if (localStorage.getItem('sk_btn1'+this.params['mulfrom'])) {
            this.sharechannel(2,0) //页面pv
          } else {
            this.btn1= this.randomWord(false, 10)
            localStorage.setItem('sk_btn1'+this.params['mulfrom'], this.btn1)
            this.sharechannel(2,1) //页面uv
          }
        } else {
          if (localStorage.getItem('sk_btn1'+'other')) {
            this.sharechannel(2,0) //页面pv
          } else {
            this.btn1= this.randomWord(false, 10)
            localStorage.setItem('sk_btn1'+'other', this.btn1)
            this.sharechannel(2,1) //页面uv
          }
        }
        window.location.href = 'https://itunes.apple.com/cn/app/testflight/id899247664?mt=8'
      } else {
        this.statis(5) // 步骤一安卓上的点击
        if ( this.params['from'] ) {
          if (localStorage.getItem('sk_btn1an'+this.params['from'])) {
            this.sharechannel(5,0) //页面pv
          } else {
            this.btn1an= this.randomWord(false, 10)
            localStorage.setItem('sk_btn1an'+this.params['from'], this.btn1an)
            this.sharechannel(5,1) //页面uv
          }
        } else if ( this.params['mulfrom'] ) {
          if (localStorage.getItem('sk_btn1an'+this.params['mulfrom'])) {
            this.sharechannel(5,0) //页面pv
          } else {
            this.btn1an= this.randomWord(false, 10)
            localStorage.setItem('sk_btn1an'+this.params['mulfrom'], this.btn1an)
            this.sharechannel(5,1) //页面uv
          }
        } else {
          if (localStorage.getItem('sk_btn1an'+'other')) {
            this.sharechannel(5,0) //页面pv
          } else {
            this.btn1an= this.randomWord(false, 10)
            localStorage.setItem('sk_btn1an'+'other', this.btn1an)
            this.sharechannel(5,1) //页面uv
          }
        }
        this.alertShow = true
        this.alertText = '请使用苹果手机扫码安装'
      }
    },
    inputEmail () {
      // vDialog.alert({
      //   message: '目前服务器正在维护，请稍后再试！',
      // })
      // return
      
      if (this.isIOS) {
        this.statis(3) // 步骤二iOS上的点击
        if ( this.params['from'] ) {
          if (localStorage.getItem('sk_btn2'+this.params['from'])) {
            this.sharechannel(3,0) //页面pv
          } else {
            this.btn2= this.randomWord(false, 10)
            localStorage.setItem('sk_btn2'+this.params['from'], this.btn2)
            this.sharechannel(3,1) //页面uv
          }
        } else if ( this.params['mulfrom'] ) {
          if (localStorage.getItem('sk_btn2'+this.params['mulfrom'])) {
            this.sharechannel(3,0) //页面pv
          } else {
            this.btn2= this.randomWord(false, 10)
            localStorage.setItem('sk_btn2'+this.params['mulfrom'], this.btn2)
            this.sharechannel(3,1) //页面uv
          }
        } else {
          if (localStorage.getItem('sk_btn2'+'other')) {
            this.sharechannel(3,0) //页面pv
          } else {
            this.btn2= this.randomWord(false, 10)
            localStorage.setItem('sk_btn2'+'other', this.btn2)
            this.sharechannel(3,1) //页面uv
          }
        }
        // this.inputShow = true
        // window.location.href = 'https://testflight.apple.com/join/a5O165vo'
        // window.location.href = 'https://testflight.apple.com/join/VhU76cak'
        window.location.href = 'https://testflight.apple.com/join/rZvw2Ydx'
      } else {
        this.statis(6) // 步骤二安卓上的点击
        if ( this.params['from'] ) {
          if (localStorage.getItem('sk_btn2an'+this.params['from'])) {
            this.sharechannel(6,0) //页面pv
          } else {
            this.btn2an= this.randomWord(false, 10)
            localStorage.setItem('sk_btn2an'+this.params['from'], this.btn2an)
            this.sharechannel(6,1) //页面uv
          }
        } else if ( this.params['mulfrom'] ) {
          if (localStorage.getItem('sk_btn2an'+this.params['mulfrom'])) {
            this.sharechannel(6,0) //页面pv
          } else {
            this.btn2an= this.randomWord(false, 10)
            localStorage.setItem('sk_btn2an'+this.params['mulfrom'], this.btn2an)
            this.sharechannel(6,1) //页面uv
          }
        } else {
          if (localStorage.getItem('sk_btn2an'+'other')) {
            this.sharechannel(6,0) //页面pv
          } else {
            this.btn2an= this.randomWord(false, 10)
            localStorage.setItem('sk_btn2an'+'other', this.btn2an)
            this.sharechannel(6,1) //页面uv
          }
        }
        this.alertShow = true
        this.alertText = '请使用苹果手机扫码安装'
      }
      
    },
    init () { // 入口初始化
      if (localStorage.getItem('sk_sid')) {
        this.sid = localStorage.getItem('sk_sid')
      } else {
        this.sid = this.randomWord(false, 16)
        localStorage.setItem('sk_sid', this.sid)
      }
      this.statis(1) // 页面UV、PV
      //ios 双开助手的统计，页面UV、PV
      if (localStorage.getItem('sk_sid'+this.params['mulfrom'])) {
        this.sid = localStorage.getItem('sk_sid'+this.params['mulfrom'])
      } else {
        this.sid = this.randomWord(false, 16)
        localStorage.setItem('sk_sid'+this.params['mulfrom'], this.sid)
      }
      if ( this.params['from'] ) {
        if (localStorage.getItem('sk_userid'+this.params['from'])) {
          this.sharechannel(1,0) //页面pv
        } else {
          this.userid= this.randomWord(false, 10)
          localStorage.setItem('sk_userid'+this.params['from'], this.userid)
          this.sharechannel(1,1) //页面uv
        }
      } else if ( this.params['mulfrom'] ) {
        if (localStorage.getItem('sk_userid'+this.params['mulfrom'])) {
          this.sharechannel(1,0) //页面pv
        } else {
          this.userid= this.randomWord(false, 10)
          localStorage.setItem('sk_userid'+this.params['mulfrom'], this.userid)
          this.sharechannel(1,1) //页面uv
        }
      } else {
        if (localStorage.getItem('sk_userid'+'other')) {
          this.sharechannel(1,0) //页面pv
        } else {
          this.userid= this.randomWord(false, 10)
          localStorage.setItem('sk_userid'+'other', this.userid)
          this.sharechannel(1,1) //页面uv
        }
      }

    },
    statis (type) { // 统计页面展示
      let mulfrom = this.params['mulfrom'] || 'nor'
      let param = qs.stringify({
        func: 7, // 内测邀请页
        sid: this.sid,
        type: type,
        mulfrom: mulfrom
      })
      this.$http.post('/push.php', param).then(res => {
        let num = parseInt(res.data.data.num)
        if (num) { 
          num = parseInt(num)
          if (typeof num == 'number') {
            this.staticNum = this.staticNum + num
          }
        }
      })
    },
    sharechannel (type,mold) { // 统计页面展示
      let mulfrom = this.params['from'] || this.params['mulfrom'] || 'other'
      let param = qs.stringify({
        mold: mold,
        type: type,
        source: mulfrom
      })
      this.$http.post('https://api.dualaid.com/htmlpage/sharechannel', param)
      // .then(res => {
      //   console.log (res.data.code)
      // })
    },
    wxShare () {
      // var THIS = this
      let ua = window.navigator.userAgent.toLowerCase()
      if (ua.match(/MicroMessenger/i) == 'micromessenger') {
        let local = location.href.split('#')[0]
        let param = qs.stringify({
          url: local
        })
        this.$http.post('/share.php', param).then(res => {
          let timestamp = res.data.timestamp // 必填，生成签名的时间戳
          let nonceStr = res.data.nonceStr // 必填，生成签名的随机串
          let signature= res.data.signature// 必填，签名
          wx.config({
            debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
            appId: "wx2124ef0427b66016", // 必填，公众号的唯一标识
            timestamp: timestamp, // 必填，生成签名的时间戳
            nonceStr: nonceStr, // 必填，生成签名的随机串
            signature: signature,// 必填，签名
            jsApiList: ["onMenuShareAppMessage","onMenuShareTimeline"] // 必填，需要使用的JS接口列表
          })
          wx.ready(function(){
              //分享到朋友圈、QQ空间
              wx.onMenuShareTimeline({
                  title: '双开助手iPhone版正式上线了', // 分享标题
                  link: local, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                  imgUrl: 'https://h5.multiopen.cn/static/logo.png', // 分享图标
                  success: function () {
                    // THIS.sharechannel(8,1)
                  },
                  cancel: function () { 
                    // THIS.sharechannel(7,1)
                  }
              })
              //分享给微信好友、QQ好友
              wx.onMenuShareAppMessage({
                  title: '双开助手iPhone版正式上线了', // 分享标题
                  desc: '马上点击申请苹果版双开助手，安全不封号、消息实时接收、无需企业证书，无广告更好用！', // 分享描述
                  link: local, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                  imgUrl: 'https://h5.multiopen.cn/static/logo.png', // 分享图标
                  type: '', // 分享类型,music、video或link，不填默认为link
                  dataUrl: '', // 如果type是music或video，则要提供数据链接，默认为空
                  success: function () {
                    // THIS.sharechannel(8,1)
                  },
                  cancel: function () { 
                    // THIS.sharechannel(7,1)
                  }
              }),
              wx.error(function(res){
                  // config信息验证失败会执行error函数
                  // 如签名过期导致验证失败，具体错误信息可以打开config的debug模式查看，
                  // 也可以在返回的res参数中查看，对于SPA可以在这里更新签名。
                  window.console.log(res)
              });
          })
        })
      } 
    }
  },
  mounted () {
    this.wxShare()
    window.onresize = () => {
      this.overWidth = document.documentElement.clientWidth
      this.overHeight = document.documentElement.clientHeight
    }
    this.$nextTick(function(){
      let moduleElem = document.getElementById('module')
      let step2 = document.getElementById('step2')
      this.scrollHeight = moduleElem.offsetHeight - step2.offsetHeight
    })
  },
  created () {
    this.setSize()
    this.init()
  }
}
</script>

<style>
* {
  padding: 0;
  margin: 0;
  box-sizing: border-box;
  background: no-repeat 0 0;
  background-size: 100% auto;
  font-size: inherit;
  font-weight: normal;
  font-style: normal;
  text-decoration: none;
  line-height: inherit;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}
body {
  width: 100%;
  height: 100%;
  height: auto;
  color: #333;
  background-color: #007eff
}
li {
  list-style: none;
}
button, input, textarea {
  outline: none;
  border: none;
}
a {
  text-decoration: none;
  color: inherit;
}
#app {
  width: 100%;
  height: 100%;
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  margin: 0 auto;
  padding: 2em 0;
  position: relative;
}
.container {
  width: 24em;
  height: auto;
  margin: 0 auto;
  background-color: #fff;
  border-radius: .5em;
  box-shadow: 0 3px 2px #3878ff;
  position: relative;
  padding: 1em 0 4em;
}
.sticky {
  width: 80%;
  margin: 0 auto;
  display: flex;
  display: -webkit-flex;
  align-items: center;
  justify-content: space-between;
}
.sticky-left,
.sticky-right {
  width: 1.25em;
  height: 1.25em;
  background-image: url('./assets/circlesticky.png')
}
.mark {
  width: 100%;
  height: 2.5em;
  position: absolute;
  /* left: -.8em; */
  bottom: 0;
  /* background-image: url('./assets/round.png'); */
  background-size: 100% 100%;
}
.app-module {
  width: 92%;
  margin: 0 auto;
}
.app-module > header {
  margin-top: 1em;
  font-weight: 500;  
}
.content-title1 {
  font-size: 1.1em;
  font-weight: 700;
  text-align: center;
  margin: .5em 0;
}
.content-title2 {
  font-size: 1.5em;
  font-weight: 700;
  text-align: center;
  margin: .5em 0;
}
.content-list li {
  display: flex;
  align-items: center;
  margin-bottom: 1em;
}
.content-list li i {
  margin-right: .5em;
}
.content-list li p {
  font-size: .9em;
  font-weight: 500;
  color: #333;
  flex: 1;
}
.right-icon {
  width: 1.2em;
  height: 1.2em;
  background-image: url('./assets/right.png');
}
.content-desc {
  margin: 1.5em 0;
  line-height: 2em;
  font-weight: 500;
}
.content-desc span {
  color: #3878ff;
  font-weight: 500;
}
/* 同时登陆两个微信 */
.img-container {
  width: 80%;
  height: 22em;
  margin: 0 auto;
  background-image: url('./assets/show.png')
}
article h2 {
  font-weight: 600;
  line-height: 1.8em;
  margin: 1% 0;
}
article p {
  color: #666;
  font-size: .86em;
  line-height: 1.8em;
}
article p>span {
  color: #f13939;
}
.step-conetnt {
  padding: 2% 0 1%;
}
.step-conetnt h3 {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 1.1em;
  margin: 1% 0;
}
.step-conetnt h3>span {
  display: flex;
  align-items: center;
}
.step-conetnt h3>a {
  color: #3866ef;
  font-size: .8em;
}
.step-icon {
  width: 1.2em;
  height: 1.2em;
  background-image: url('./assets/text.png');
  margin-right: .3em;
}
.step {
  margin-bottom: .5em;
  border: 1px solid #bdbdbd;
  border-radius: .5em;
  padding: .5% 1em;
}
.step h4 {
  font-size: 1.1em;
  text-align: center;
  line-height: 2.2em;
  font-weight: 500;
}
.step button {
  display: block;
  width: 100%;
  font-size: 1.1em;
  line-height: 2.6em;
  border-radius: 3em;
  margin: 2% 0;
}
.step-1 button {
  color: #3866ef;
  border: 1px solid #3866ef;
}
.step-2 button {
  color: #fff;
  background: linear-gradient(60deg, #3866ef, #523fec)
}
.description {
  color: rgb(50, 63, 253);
  font-size: .8em;
  text-align: center;
}
.strong {
  color: rgb(235, 48, 48);
  font-weight: 600;
}
</style>
